import * as React from 'react';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import Image from 'components/atoms/Image';
import { ImageProps } from 'components/atoms/Image';
import Intensity from 'components/atoms/Intensity';
import { generateClassNameString } from 'helper/css';
import i18n from 'helper/i18n';

type InfoType = {
	value?: string;
	unit?: string;
	add?: string;
};

type PoolTeaserPropsType = {
	tag: string;
	headline: string;
	link: string;
	infos?: InfoType[];
	image: ImageProps;
	customImage?: React.ReactNode;
	intensity?: number;
	modifier?: string | string[];
};

const renderPoolTeaserIntensity = (intensity: number) => (
	<React.Fragment>
		<span className="o-pool-teaser__info-divider">{' / '}</span>
		{`${i18n('react.impulsCoach.components.poolTeaser.intensity')} `}
		<span className="o-pool-teaser__info-intensity">
			<Intensity value={intensity} modifier="dark" />
		</span>
	</React.Fragment>
);

export const PoolTeaser = ({
	link = '#',
	modifier,
	tag,
	headline,
	image,
	infos = [],
	customImage,
	intensity,
}: PoolTeaserPropsType) => {
	return (
		<div className={generateClassNameString('o-pool-teaser', modifier)}>
			<Link className="o-pool-teaser__link" to={link}>
				<div className="o-pool-teaser__content">
					<div className="o-pool-teaser__image">
						{customImage && customImage}
						{image && <Image {...image} />}
					</div>
					<div className="o-pool-teaser__text">
						<div className="o-pool-teaser__tag">{tag}</div>
						<h2 className="o-pool-teaser__headline">{headline}</h2>
					</div>
				</div>
				<div className="o-pool-teaser__info">
					{infos.map(({ value, unit, add }: InfoType, index) => {
						return (
							<React.Fragment key={index}>
								{value && ` ${value} `}
								{unit && <small>{unit}</small>}
								{add && add}
								{index !== infos.length - 1 && (
									<span className="o-pool-teaser__info-divider">{' / '}</span>
								)}
							</React.Fragment>
						);
					})}
					{intensity && renderPoolTeaserIntensity(intensity)}
				</div>
			</Link>
		</div>
	);
};

export default memo(PoolTeaser);
